import { PageType } from "../../../constants/types.constants";
import { BirthPageCreateEntity } from "../entities/birth-page-create.entity";

interface Params {
  imageName: string;
  description: string;
  type: PageType;
}

export class BirthPageCreateModel {
  imageName: string;
  description: string;
  type: PageType;

  constructor(params: Params) {
    this.imageName = params.imageName;
    this.description = params.description;
    this.type = params.type;
  }

  static fromEntity = (entity: BirthPageCreateEntity) =>
    new BirthPageCreateModel({
      ...entity,
    });
}
